<template>
  <div class="progressBarStacked">
    <div class="progress" tabindex="0">
      <template v-if="meterValues">
        <span
          class="progress-meter"
          :class="value.color || ''"
          :style="{ width: value.percent + '%' }"
          v-for="(value, $index) in meterValues"
          :key="$index">
          <span class="progress-meter-text" v-if="value.label">{{ value.label }}</span>
        </span>
      </template>
    </div>
    <div v-if="legendValues">
      <span class="legend-value" v-for="(value, $index) in legendValues" :key="$index">
        <span class="legend-color" :class="value.color"></span>
        {{ value.legend }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    values: Array // [{ percent: 25, color: 'alert', legend: 'Deleted', label: '2,000' }]
  },
  computed: {
    meterValues () {
      if (!this.values) {
        return null
      }
      return this.values.filter(value => !!value.percent)
    },
    legendValues () {
      if (!this.values) {
        return null
      }
      const legend = this.values.filter(value => !!value.legend)
      return legend.length > 0 ? legend : null
    }
  }
}
</script>

<style lang="scss">
@import "../../style/settings";

.progressBarStacked {
  .progress {
    height: 1.2rem;

    .progress-meter {
      display: inline-block;
      height: 1.2rem;

      &:not(:last-child) {
        border-right: solid #FFF rem-calc(1);
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }

      &:not(:first-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }
  .legend-value {
    margin-right: 1em;

    .legend-color {
      display: inline-block;
      width: 0.7em;
      height: 0.7em;
      border-radius: 50%;
      margin-right: 0.1em;
    }
  }
  .progress-meter,
  .legend-color {
    &.primary {
      background: get-color(primary);
    }

    &.secondary {
      background: get-color(secondary);
    }

    &.success {
      background: get-color(success);
    }

    &.warning {
      background: get-color(warning);
    }

    &.alert {
      background: get-color(alert);
    }
  }
}
</style>
